import { usePageTitle } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { useSelector } from 'react-redux'

import { isScimFeatureEnabledSelector } from './selectors'
import { SetupComponent } from './setup_component'
import { Upgrade as UserProvisioningUpgrade } from './upgrade'

export const UserProvisioningPage = () => {
  const isScimFeatureEnabled = useSelector(isScimFeatureEnabledSelector)

  usePageTitle(`${I18n.t('publisher.admin.login.tabs.user_provisioning')} - ${I18n.t('publisher.admin.login.title')}`)

  if (!isScimFeatureEnabled) {
    return <UserProvisioningUpgrade />
  }
  return <SetupComponent />
}
